export default "__VITE_ASSET__c8874893__"